/* Local About interactions. No API calls, synchronization or polling. */
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.aboutInitialized === 'true') return;
    root.dataset.aboutInitialized = 'true';
    const works = root.querySelector('[data-about-works]');
    if (works) {
      const cards = Array.from(works.children);
      for (let i = cards.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      works.replaceChildren(...cards);
      const previous = root.querySelector('[data-works-prev]');
      const next = root.querySelector('[data-works-next]');
      const updateControls = () => {
        const image = works.querySelector('.product-card img');
        if (image) root.querySelector('.about-works-controls').style.top = `${image.getBoundingClientRect().height / 2}px`;
        previous.disabled = works.scrollLeft <= 2;
        next.disabled = works.scrollLeft >= works.scrollWidth - works.clientWidth - 2;
      };
      const move = (direction) => works.scrollBy({
        left: direction * (cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(works).columnGap)),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      works.addEventListener('scroll', updateControls, { passive: true });
      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(works);
      root.addEventListener('about:destroy', () => resizeObserver.disconnect(), { once: true });
      updateControls();
    }
    const viewer = root.querySelector('.about-image-viewer');
    if (!viewer || typeof viewer.showModal !== 'function') return;
    const viewerImage = viewer.querySelector('img');
    const viewerCaption = viewer.querySelector('figcaption');
    let lastImageButton;

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-zoom]');
      if (!button || !root.contains(button)) return;
      lastImageButton = button;
      viewerImage.src = button.dataset.zoom;
      viewerImage.alt = button.querySelector('img')?.alt || '';
      const caption = document.createElement('div');
      caption.innerHTML = (button.dataset.caption || '').replace(/<span>/g, ' · <span>');
      viewerCaption.textContent = caption.textContent;
      viewer.showModal();
      document.body.classList.add('fotografista-about-viewer-open');
    });
    viewer.querySelector('.viewer-close').addEventListener('click', () => viewer.close());
    viewer.addEventListener('click', (event) => {
      if (event.target !== viewer) return;
      const bounds = viewer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) viewer.close();
    });
    viewer.addEventListener('close', () => {
      document.body.classList.remove('fotografista-about-viewer-open');
      lastImageButton?.focus({ preventScroll: true });
    });

    if ('IntersectionObserver' in window) {
      const links = [...root.querySelectorAll('.date-nav a')];
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (!visible.length) return;
        const id = visible[0].target.id;
        links.forEach((link) => {
          const active = link.getAttribute('href') === '#' + id;
          link.classList.toggle('active', active);
          if (active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-12% 0px -45% 0px', threshold: 0 });
      root.querySelectorAll('#m1826, #m1925, #m1935, #m1975, #m2026').forEach((element) => observer.observe(element));
      root.addEventListener('about:destroy', () => observer.disconnect(), { once: true });
    }
  };

  document.querySelectorAll('[data-fotografista-about]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-fotografista-about]')));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-fotografista-about]');
    root?.dispatchEvent(new Event('about:destroy'));
    document.body.classList.remove('fotografista-about-viewer-open');
  });
})();
